/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
    ADD_CREATESCHEDULE(state, item) {
        state.getAllCreateSchedule.unshift(item)
    },
    UPDATE_CREATESCHEDULE(state, item) {
        const index = state.getAllCreateSchedule.findIndex((e) => e.createScheduleId === item.createScheduleId)
        Object.assign(state.getAllCreateSchedule[index], item)
    },
    GET_ALL_CREATESCHEDULE(state, payload) {
        state.getAllCreateSchedule = payload
        
    },
    // CURRENT_SCHEDULE(state, items) {
    //     console.log('CURRENT_SCHEDULE')
    //     console.log(items)
    //     state.getAllEmployeeSchedule = items
    // }


}